'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the translation data
 * @param {GetTranslationTokenDataParamsType} params Get Translation data parameters
 * @returns {Promise<Map<*, *>>} A map of the required data
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var _params$lang, lang, _params$product, product, tunnel, endpoint, proxyAgent, response;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _params$lang = params.lang, lang = _params$lang === undefined ? 'en-gb' : _params$lang, _params$product = params.product, product = _params$product === undefined ? 'sportsbook' : _params$product, tunnel = params.tunnel;
                        endpoint = (0, _getEndpoint2.default)('squiz', '/' + product + '/' + lang + '/site-base/translation-tokens.json');
                        proxyAgent = (0, _config.getProxy)('squiz');
                        _context.next = 5;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 5:
                        response = _context.sent;

                        if (!response.error) {
                            _context.next = 8;
                            break;
                        }

                        throw new Error(response.error);

                    case 8:
                        return _context.abrupt('return', (0, _model2.default)(response.data));

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getTranslationTokenData(_x) {
        return _ref.apply(this, arguments);
    }

    return getTranslationTokenData;
}();
//# sourceMappingURL=translationToken.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/translation-token/translationToken.js
// module id = 462
// module chunks = 0